import React from 'react';
import { Box, Paragraph, Text } from 'bumbag';

import T from '../common/ReactTMinus';
type Props = {
  redirectUrl: string;
};
const ALLOWED_PROTOCOLS = ['http:', 'https:'];
export default class ReactCountdown extends React.PureComponent<Props> {
  handleCompleteCountdown = () => {
    const { redirectUrl } = this.props;

    // Check to make sure the redirect url is actually a url, to prevent XSS attacks
    try {
      const checkUrl = new URL(redirectUrl);

      if (checkUrl?.hostname && ALLOWED_PROTOCOLS.includes(checkUrl?.protocol)) {
        window.location.href = redirectUrl || '/';
      } else {
        window.location.href = '/';
      }
    } catch (err) {
      window.location.href = '/';
    }
  };
  render = () => {
    return (
      <Box {...this.props}>
        <T minus={5} onComplete={this.handleCompleteCountdown}>
          {({ secondsLeft }) => (
            <Paragraph>
              Redirecting back to your service provider in{' '}
              <Text fontWeight="semibold">{secondsLeft === 0 ? 'Redirecting' : secondsLeft}</Text>...
            </Paragraph>
          )}
        </T>
      </Box>
    );
  };
}
